import React from 'react';
import { styled } from 'baseui';
import { useAtomValue } from 'jotai';
import { frameCountAtom } from '../../../image/labelling-v2/atoms/annotation-atoms';
import { useEditHandler } from '../../side-panel/annotation-details/hooks/use-edit-handler';
import { useLockHandler } from '../../side-panel/annotation-details/hooks/use-lock-handler';
import { useObjectInstantiationHandler } from '../../side-panel/annotation-details/hooks/use-object-instantiation-handler';
import type { AnnotationInfoT } from '../../side-panel/annotations/types';
import { useSidePanel } from '../../side-panel/side-panel-provider';
import { useVisibilityMode } from './hooks/use-visibility-mode';
import { AnnotationContent } from './annotation-content';
import { MoreActionsButton } from './more-actions-button';
type PropsT = {
  annotation: AnnotationInfoT;
  icon: React.ReactNode;
  handleDeleteAnnotation: (annotation: AnnotationInfoT) => void;
};
const Container = styled<'div', {
  $disabled: boolean;
}>('div', ({
  $disabled,
  $theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  margin: 0,
  padding: 0,
  opacity: $disabled ? 0.5 : 1,
  width: '100%',
  overflow: 'hidden',
  paddingRight: $theme.sizing.scale200
}));
const ActionButtonsRow = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale200,
  justifyContent: 'flex-end'
}));
export const AnnotationHeader = ({
  annotation,
  icon,
  handleDeleteAnnotation
}: PropsT) => {
  const {
    isDisabled
  } = annotation;
  const {
    handleEditAnnotation
  } = useEditHandler({
    annotation
  });
  const {
    handleObjectInstantiation
  } = useObjectInstantiationHandler({
    annotation
  });
  const {
    selectedAnnotationIdsAtom
  } = useSidePanel();
  const selectedAnnotationIds = useAtomValue(selectedAnnotationIdsAtom);
  const isSelected = selectedAnnotationIds.includes(annotation.id);
  const {
    isShowAll,
    toggleShowAll
  } = useVisibilityMode();
  const {
    handleLockAnnotation
  } = useLockHandler({
    annotation
  });
  const numFrames = useAtomValue(frameCountAtom);
  return <Container $disabled={isDisabled}>
      <AnnotationContent annotation={annotation} icon={icon} />
      <ActionButtonsRow onClick={event => event.stopPropagation()}>
        <MoreActionsButton annotation={annotation} onEditClick={handleEditAnnotation} onTrackClick={undefined} onLockClick={locked => handleLockAnnotation(locked)} onVisibilityClick={toggleShowAll} isSelected={isSelected} showAllAnnotations={isShowAll} onDeleteClick={() => handleDeleteAnnotation(annotation)} onCopyInstanceClick={annotation.canCopyObjectInstance && numFrames > 1 ? handleObjectInstantiation : undefined} />
      </ActionButtonsRow>
    </Container>;
};